import React from "react";
import withStyles from '@mui/styles/withStyles';
import Tooltip from "@mui/material/Tooltip";

const styles = {
    tooltip: {
        fontSize: '13px'
    }
};

const CustomTooltip = withStyles(styles)(Tooltip);

/**
 * Custom locale styling for material-ui tooltip
 */
const StandardTooltip = (props) => {
    return (
        <CustomTooltip
            enterDelay={750}
            leaveDelay={50}
            {...props}
        >
             {props.children}
        </CustomTooltip>
   );
}

StandardTooltip.defaultProps = {
    placement: 'bottom',
}
export default StandardTooltip;
